import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

function socketBaseUrl(): string {
  // Production: same origin (Nginx proxies /socket.io to API).
  // Dev: talk to API directly — CRA proxy often breaks Socket.IO websockets
  // (symptom: messages from the other app arrive only on poll ~30s).
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin;
  }
  return (process.env.REACT_APP_API_URL || 'http://localhost:5002/api').replace(/\/api\/?$/, '');
}

export function getChatSocket(): Socket {
  if (socket?.connected) return socket;
  const token = localStorage.getItem('token');
  if (socket) {
    socket.auth = { token };
    socket.connect();
    return socket;
  }
  socket = io(socketBaseUrl(), {
    path: '/socket.io',
    auth: { token },
    transports: ['websocket', 'polling'],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
  });
  return socket;
}

export function disconnectChatSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
